import i18n from '@batical/i18n'
import { RLogementCompositionECSSchema_Type } from '@batical/types/src'
import { fetchGeneric } from './GenericQ'
const DataLogementCompositionECS = require('../json/LogementCompositionECS.json')

export function fetchECSTypeLogementSorted(): Array<{
  value: string
  label: string
}> {
  const listeLogement = [
    { value: '0', label: 'ECS1_TYPE_LOGEMENT0' },
    { value: '1', label: 'ECS1_TYPE_LOGEMENT1' },
    { value: '2', label: 'ECS1_TYPE_LOGEMENT2' },
    { value: '3', label: 'ECS1_TYPE_LOGEMENT3' }
  ]
  return listeLogement
}
// ECS1_TYPE_LOGEMENT0: 'Logements standards Habitat social',
// ECS1_TYPE_LOGEMENT1: 'Logements standards Habitat privé',
// ECS1_TYPE_LOGEMENT2: 'Type de logements social',
// ECS1_TYPE_LOGEMENT3: 'Type de logements privé',
export function fetchECSTypeLogementSortedTranslate(): Array<{
  value: string
  label: string
}> {
  const listeLogement = [
    { value: '0', label: i18n.t('ECS1_TYPE_LOGEMENT0') },
    { value: '1', label: i18n.t('ECS1_TYPE_LOGEMENT1') },
    { value: '2', label: i18n.t('ECS1_TYPE_LOGEMENT2') },
    { value: '3', label: i18n.t('ECS1_TYPE_LOGEMENT3') }
  ]
  return listeLogement
}
//RLogementCompositionECSSchema

export function fetchLogementCompositionECS(uuid: string): RLogementCompositionECSSchema_Type {
  return fetchGeneric(DataLogementCompositionECS, uuid)
}
